module.exports = __webpack_public_path__ + "static/media/close_modal_icon.e64768dd.svg";